var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgReisLogo = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "87px",
    height: "42px",
    viewBox: "0 0 87 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F2C1DE69-BEE0-4D62-A8A1-D4EDC665465C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REIS_Wiregrame-V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "REIS_Homepage",
    transform: "translate(-597.000000, -11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(597.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "EIX-Logo-horizontal/White-Text/EIX-logo_horizontal_white",
    transform: "translate(13.000000, 10.000000)",
    fill: "#FFFFFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,21.269 L0,0.939 L8.39250866,0.939 C11.9288637,0.939 13.9096632,3.66903516 13.9096632,6.93170387 C13.9096632,10.0352742 11.7481901,11.3818456 8.84419263,11.7622982 L14,21.269 L9.98111426,21.269 L4.67548001,10.8515179 L4.91564369,10.8515179 C8.15454832,10.8515179 10.2521246,9.53261574 10.2521246,6.49130124 C10.2521246,4.23394953 9.20113314,1.94201123 5.63613472,1.94201123 L3.65974189,1.94201123 L3.65974189,21.269 L0,21.269",
    id: "Fill-10"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-19",
    points: "19.85 20.888 19.851 0.563 31.864 0.563 31.864 1.881 23.677 1.881 23.677 9.721 31.393 9.721 31.393 11.04 23.677 11.039 23.677 19.571 31.989 19.571 31.989 20.888 19.85 20.888"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-21",
    points: "38.898 20.889 38.898 0.569 42.724 0.565 42.724 20.889 38.898 20.889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.694,17.251 C50.762,18.946 51.891,19.854 53.897,19.854 C55.654,19.854 57.537,18.444 57.537,16.342 C57.537,10.445 48.001,13.236 48.002,5.96 C48.002,2.697 50.73,0 54.525,0 C57.035,0 59.576,1.381 60.642,3.638 L59.324,4.486 C58.541,2.855 57.316,1.599 55.153,1.599 C53.051,1.599 51.828,3.199 51.828,5.144 C51.828,9.911 61.363,7.905 61.363,15.244 C61.363,18.977 58.101,21.454 54.682,21.454 C51.922,21.454 49.694,20.638 48.283,18.286 L49.694,17.251",
    id: "Fill-22"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 85,
    height: 40
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReisLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reis_logo.9725579b30ab9a672869b57ebb9a6fa6.svg";